import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { photos, categories } from '../data/mock';
import { PhotoNav } from '../components/photo/PhotoNav';
import { PhotoInfo } from '../components/photo/PhotoInfo';
import { RelatedPhotos } from '../components/photo/RelatedPhotos';
import { usePageMeta } from '../hooks/use-page-meta';

const PhotoNotFound = ({ onBack }) => (
  <div className="min-h-screen bg-[#1a1a1a] flex items-center justify-center" style={{ paddingTop: '100px' }} data-testid="photo-not-found">
    <div className="text-center">
      <h1 className="section-title">Photo Not Found</h1>
      <button onClick={onBack} className="hero-cta mt-lg" data-testid="photo-back-to-gallery-btn">
        Back to Gallery
      </button>
    </div>
  </div>
);

export const PhotoDetailPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const currentIndex = photos.findIndex(p => p.id === parseInt(id));
  const photo = photos[currentIndex];
  const metaCategory = photo ? categories.find(c => c.id === photo.category)?.name : '';
  usePageMeta({
    title: photo ? `${photo.title} – ${metaCategory} Photography` : 'Photo Not Found',
    description: photo ? `${photo.title}: ${metaCategory} photography in Dubai by Elina K. Book your own session.` : 'This photo could not be found.',
    path: `/photo/${id}`,
    image: photo?.image
  });
  const goToPhoto = (photoId) => navigate(`/photo/${photoId}`);

  if (!photo) return <PhotoNotFound onBack={() => navigate('/gallery')} />;

  const categoryName = categories.find(c => c.id === photo.category)?.name || photo.category;
  const relatedPhotos = photos.filter(p => p.category === photo.category && p.id !== photo.id);

  return (
    <div className="min-h-screen bg-[#1a1a1a]" style={{ paddingTop: '100px' }} data-testid="photo-detail-page">
      <div className="revolt-container section-spacing">
        <button
          onClick={() => navigate('/gallery')}
          className="flex items-center gap-2 text-[#888] hover:text-white transition-colors mb-8 text-sm tracking-wide uppercase"
          style={{ fontFamily: 'Montserrat, sans-serif' }}
          data-testid="photo-back-btn"
        >
          <ArrowLeft className="w-4 h-4" />
          Back to Portfolio
        </button>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
          <div className="relative">
            <img src={photo.image} alt={photo.title} className="w-full h-auto" data-testid="photo-main-image" />
            <PhotoNav
              prevPhoto={photos[currentIndex - 1]}
              nextPhoto={photos[currentIndex + 1]}
              onNavigate={goToPhoto}
            />
          </div>

          <PhotoInfo
            photo={photo}
            categoryName={categoryName}
            onBook={() => navigate('/contact', { state: { category: photo.category } })}
          />
        </div>

        <RelatedPhotos photos={relatedPhotos} categoryName={categoryName} onPhotoClick={goToPhoto} />
      </div>
    </div>
  );
};
